//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "hTag",
    props: {
        border: {
            type: Boolean,
            default: true
        },
        checkable: {
            type: Boolean,
            default: false
        },
        closeable: {
            type: Boolean,
            default: false
        },
        name: {
            type: String
        },
        value: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            isChecked: this.value,
            showClose: false
        }
    },
    computed: {
        containerClass: function () {
            return {
                checked: this.isChecked,
            }
        },
        containerStyle: function () {
            var style = {};
            if (this.border) {
                style['border'] = '1px solid #dddee1'
                style['border-radius'] = '0.2rem';
            }
            return style;
        }
    },
    methods: {
        check: function (event) {
            if(!this.checkable) return;
            this.isChecked = !this.isChecked;
            if (this.name !== undefined) {
                this.$emit(this.isChecked ? "on-check" : "on-uncheck", event, this.name);
            } else {
                this.$emit(this.isChecked ? "on-check" : "on-uncheck", event);
            }
            this.$emit('input', this.isChecked);
            this.$emit('change', this.isChecked);
        },
        close: function (event) {
            if (this.name !== undefined) {
                this.$emit("on-close", event, this.name);
            } else {
                this.$emit("on-close", event);
            }
        }
    },
    watch: {
        value: function (newValue) {
            this.isChecked = !!newValue;
        }
    }
}

